import { useState } from "react";
import { Row, Col, Badge, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// SecurityRow Component
interface SecurityRowProps {
  title: string;
  description: string;
  checked?: boolean;
  onToggle?: () => void;
  noBorder?: boolean;
  manageRoute?: string;
  manageText?: string; 
}

const SecurityRow: React.FC<SecurityRowProps> = ({
  title,
  description,
  checked,
  onToggle,
  noBorder = false,
  manageRoute,
  manageText = "Manage", 
}) => {
  const navigate = useNavigate();

  return (
    <div
      className={`d-flex justify-content-between align-items-center py-3 ${
        noBorder ? "" : "border-bottom"
      }`}
    >
      <div>
        <h6 className="mb-1">{title}</h6>
        <p className="text-muted small mb-0">{description}</p>
      </div>
      <div className="d-flex align-items-center">
        {onToggle && (
          <Form.Check
            type="switch"
            id={`switch-${title}`}
            checked={!!checked}
            onChange={onToggle}
            className="me-3"
          />
        )}
        {manageRoute && (
          <Button
            variant="outline-secondary"
            size="sm"
            onClick={() => navigate(manageRoute)}
          >
            {manageText} 
          </Button>
        )}
      </div>
    </div>
  );
};



// Main Component
const AccountSecuritySection: React.FC = () => {
  const [securityOptions, setSecurityOptions] = useState({
    passkeys: false,
    authApp: true,
    deviceLock: true,
  });

  const toggleOption = (key: keyof typeof securityOptions) => {
    setSecurityOptions((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  return (
    <Row className="mt-1">
      <Col md={12}>
        {/* Identity Verification */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <strong>Identity Verification</strong>
          <Badge bg="light" text="dark" className="rounded-pill px-3 py-2 shadow-sm">
            <i className="bi bi-patch-check-fill me-1 text-success"></i> Verified
          </Badge>
        </div>

        {/* Security Options */}
        <div className="bg-light rounded-4 p-4 shadow-sm">
          <SecurityRow
            title="Passkeys and Security Keys"
            description="Protect your account and withdrawals with passkeys and / or security keys."
            checked={securityOptions.passkeys}
            onToggle={() => toggleOption("passkeys")}
            manageRoute="/settings/passkeys"
          />
          <SecurityRow
            title="Authenticator App"
            description="Enable two-factor authentication via an authenticator app."
            checked={securityOptions.authApp}
            onToggle={() => toggleOption("authApp")}
            manageRoute="/settings/auth-app"
          />
          <SecurityRow
            title="Password"
            description="Last Changed Jun 10,2025"
            manageRoute="/settings/device-lock"
          />
          <SecurityRow
            title="Recovery Email"
            description="farhanramzan@outlook.com"
            manageRoute="/settings/device-lock"
          />
          <SecurityRow
            title="Recovery Phone"
            description="+923083656611"
            manageRoute="/settings/device-lock"
          />
          <SecurityRow
            title="Trustees"
            description="+923083656611"
            manageRoute="/settings/device-lock"
          />
          <SecurityRow
            title="Device Lock"
            description="Allow logins only from verified devices."
            checked={securityOptions.deviceLock}
            onToggle={() => toggleOption("deviceLock")}
            manageRoute="/settings/device-lock"
            noBorder
          />
        </div>
      </Col>
    </Row>
  );
};

export default AccountSecuritySection;